<template>
  <ui-sheet v-model="model" :title="$t('report_mobile.choose_month')">
    <div class="rm-month-year">
      <button
        type="button"
        class="rm-icon-btn"
        :aria-label="$t('report_mobile.prev_year')"
        @click="year -= 1"
      >
        <v-icon size="20" color="#1c1917">mdi-chevron-left</v-icon>
      </button>
      <span class="rm-month-year__value rm-num">{{ year }}</span>
      <button
        type="button"
        class="rm-icon-btn"
        :aria-label="$t('report_mobile.next_year')"
        @click="year += 1"
      >
        <v-icon size="20" color="#1c1917">mdi-chevron-right</v-icon>
      </button>
    </div>

    <div class="rm-month-grid">
      <button
        v-for="item in months"
        :key="item.value"
        type="button"
        class="rm-month-grid__btn"
        :class="{ 'is-active': item.value === month, 'is-current': item.value === currentMonth }"
        :aria-pressed="String(item.value === month)"
        @click="pick(item.value)"
      >
        {{ item.label }}
      </button>
    </div>
  </ui-sheet>
</template>

<script>
import moment from "moment";
import hasModel from "@/mixins/hasModel";

/** Izbor meseca ("YYYY-MM") za mesečni pregled radnika. */
export default {
  name: "ReportMobileMonthSheet",
  mixins: [hasModel],
  props: {
    /** Izabrani mesec, "YYYY-MM" */
    month: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    year: 0,
  }),
  computed: {
    currentMonth() {
      return moment().format("YYYY-MM");
    },
    months() {
      const locale = this.formatLocale();
      const formatter = new Intl.DateTimeFormat(locale, { month: "short" });
      return Array.from({ length: 12 }, (_, index) => {
        const label = formatter.format(new Date(2026, index, 1)).replace(/\.$/, "");
        return {
          value: `${this.year}-${String(index + 1).padStart(2, "0")}`,
          label: label.charAt(0).toUpperCase() + label.slice(1),
        };
      });
    },
  },
  watch: {
    value: {
      handler(isOpen) {
        if (isOpen) {
          this.year = Number(this.month.slice(0, 4));
        }
      },
      immediate: true,
    },
    month() {
      this.year = Number(this.month.slice(0, 4));
    },
  },
  methods: {
    formatLocale() {
      const config = this.getCurrentLanguageConfig();
      return config.script === "latin" && config.locale === "sr-RS" ? "sr-Latn-RS" : config.locale;
    },
    pick(value) {
      this.$emit("select", value);
      this.model = false;
    },
  },
};
</script>

<style lang="scss">
.rm-month-year {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__value {
    font-size: 16px;
    font-weight: 700;
  }
}

.rm-month-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;

  &__btn {
    height: 52px;
    border-radius: 12px;
    border: 1px solid var(--rm-border-strong);
    background: var(--rm-surface);
    color: var(--rm-text);
    font-size: 15px;
    font-weight: 500;

    &.is-current {
      border-color: var(--rm-inverse);
      font-weight: 700;
    }

    &.is-active {
      border: 2px solid var(--rm-accent);
      background: var(--rm-accent-soft);
      color: var(--rm-accent-strong);
      font-weight: 700;
    }
  }
}
</style>
